import { graphql } from "gatsby";
import TermAndConditionsPage from "../../../../src/pages/terms-and-conditions";
import * as React from 'react';
export default {
  graphql,
  TermAndConditionsPage,
  React
};